/* Moved from sections/hlth-golden-ratio-v2-egg.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
(function () {
  function run(SID) {
      (function() {
        var sectionId = SID;
        var root = document.querySelector('[data-v2-egg="' + sectionId + '"]');
        if (!root) return;

        /* ── Count-up + reveal ── */
        var numEl = root.querySelector('.v2-stat-val');
        var target = numEl ? (parseInt(numEl.getAttribute('data-stat-target'), 10) || 0) : 0;
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var animated = false;

        function runReveal() {
          if (animated) return;
          animated = true;
          if (reduced) {
            if (numEl) numEl.textContent = target;
            root.classList.add('is-animated');
            return;
          }
          root.classList.add('is-animated');
          if (!numEl) return;
          var start = null, duration = 1100;
          numEl.textContent = 0;
          function step(ts) {
            if (!start) start = ts;
            var progress = Math.min((ts - start) / duration, 1);
            var eased = 1 - Math.pow(1 - progress, 3);
            numEl.textContent = Math.round(eased * target);
            if (progress < 1) requestAnimationFrame(step);
          }
          requestAnimationFrame(step);
        }

        if ('IntersectionObserver' in window) {
          var io = new IntersectionObserver(function(entries) {
            entries.forEach(function(e) {
              if (e.isIntersecting) { runReveal(); io.disconnect(); }
            });
          }, { threshold: 0.25 });
          io.observe(root);
        } else { runReveal(); }

        /* ── Drawer logic ── */
        var drawer   = document.getElementById('v2-egg-drawer-' + sectionId);
        var backdrop = document.querySelector('.v2-egg-drawer-' + sectionId + '-backdrop');
        var triggers = root.querySelectorAll('[data-v2-egg-drawer-trigger]');
        var closeBtn = drawer ? drawer.querySelector('[data-v2-egg-drawer-close]') : null;
        var lockClass = 'v2-egg-drawer-' + sectionId + '-locked';
        var lastTrigger = null;

        if (!drawer || !backdrop) return;

        function getFocusable(el) {
          return Array.prototype.slice.call(
            el.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"]), input, select, textarea')
          ).filter(function(node) { return node.offsetParent !== null || node === document.activeElement; });
        }

        function openDrawer(trigger) {
          lastTrigger = trigger || null;
          drawer.classList.add('is-open');
          backdrop.classList.add('is-open');
          drawer.setAttribute('aria-hidden', 'false');
          backdrop.setAttribute('aria-hidden', 'false');
          document.documentElement.classList.add(lockClass);
          triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'true'); });
          setTimeout(function() { (closeBtn || drawer).focus({ preventScroll: true }); }, 60);
          document.addEventListener('keydown', onKeydown);
        }

        function closeDrawer() {
          drawer.classList.remove('is-open');
          backdrop.classList.remove('is-open');
          drawer.setAttribute('aria-hidden', 'true');
          backdrop.setAttribute('aria-hidden', 'true');
          document.documentElement.classList.remove(lockClass);
          triggers.forEach(function(t) { t.setAttribute('aria-expanded', 'false'); });
          document.removeEventListener('keydown', onKeydown);
          if (lastTrigger && typeof lastTrigger.focus === 'function') {
            lastTrigger.focus({ preventScroll: true });
          }
        }

        function onKeydown(e) {
          if (e.key === 'Escape') { e.preventDefault(); closeDrawer(); return; }
          if (e.key === 'Tab') {
            var focusables = getFocusable(drawer);
            if (!focusables.length) return;
            var first = focusables[0], last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
          }
        }

        triggers.forEach(function(t) {
          t.addEventListener('click', function(e) { e.preventDefault(); openDrawer(t); });
        });
        if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
        backdrop.addEventListener('click', closeDrawer);

        document.addEventListener('shopify:section:unload', function(e) {
          if (e.detail && e.detail.sectionId === sectionId) {
            document.documentElement.classList.remove(lockClass);
            document.removeEventListener('keydown', onKeydown);
          }
        });
      })();
  }
  function scan(scope) {
    var list = [];
    if (scope.classList && scope.classList.contains('hlth-s--hlth-golden-ratio-v2-egg')) list.push(scope);
    scope.querySelectorAll('.hlth-s--hlth-golden-ratio-v2-egg').forEach(function (w) { list.push(w); });
    list.forEach(function (w) {
      if (w.__hlthJs_hlth_golden_ratio_v2_egg) return;
      w.__hlthJs_hlth_golden_ratio_v2_egg = true;
      run(w.id.replace(/^shopify-section-/, ''));
    });
  }
  scan(document);
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
